import React, { useEffect, useState } from "react";
import "./Terms_and_condition.css";
import {
  faClipboardQuestion,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Accordion } from "react-bootstrap";
import Contact_details_card from "../../common_components/contact_details_card/Contact_details_card";
import {
  luxuryPrivacyPolicy,
  luxuryTermCondition,
} from "../../../utils/luxuryapis/Home/Homeapi";
import parse from "html-react-parser";
import { formatDate } from "../../../utils/apis/common/Common";
const firstAccordionItems = [
  {
    title: "1. Personal data & privacy policy",
    content:
      "The privacy policy governs the processing of any personal information that you provide on this website. The privacy policy may be updated at any time without notice by posting such updates on this website. You can find the complete text of the privacy policy via the hyperlink labeled 'privacy and cookies' in the 'legal' section of the footer of the website. Please read the privacy policy carefully, as it governs the processing of your personal information. The website is intended only for use by individuals 13 years of age and older.",
  },
  {
    title: "2. Intellectual property",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
  // repeat objects for all other items (eventKey 2 to 8)
];

const secondAccordionItems = [
  {
    title: "1. Scope and Agreement on the Terms and Conditions of Sale",
    content:
      "The privacy policy governs the processing of any personal information that you provide on this website. The privacy policy may be updated at any time without notice by posting such updates on this website. You can find the complete text of the privacy policy via the hyperlink labeled 'privacy and cookies' in the 'legal' section of the footer of the website. Please read the privacy policy carefully, as it governs the processing of your personal information. The website is intended only for use by individuals 13 years of age and older.",
  },
  {
    title: "2. Reservation Conditions – Customer Account – Placing an Order",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
  {
    title: "3. Products availability",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
  {
    title: "4. Order confirmation",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
  {
    title: "5. Price payment",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
];

function Terms_and_condition() {
  const [data, setData] = useState({});

  const getData = async () => {
    const res = await luxuryTermCondition();
    if (res?.success) {
      setData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <section className="Legal_notice accordian_holder">
      <div className="custom_container">
        <div className="row">
          <div className="col-md-8">
            <div className="content_box_holder">
              <div className="heading_strip_holder">
                <h1>GENERAL TERMS AND CONDITIONS OF USE</h1>
              </div>
            </div>

            <div className="content_box_holder">
              <div className="content_holder">
                <div className="text_holder">
                  <p>Last updated {formatDate(data?.createdAt)}</p>
                  <h4>{data?.name}</h4>
                  <hr />

                  {typeof data?.description === "string"
                    ? parse(data?.description)
                    : ""}

                  {/* <Accordion defaultActiveKey="0">
                    {firstAccordionItems.map((item, index) => (
                      <Accordion.Item eventKey={index.toString()} key={index}>
                        <Accordion.Header>{item.title}</Accordion.Header>
                        <Accordion.Body><p>{item.content}</p></Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>

                  <hr />
                  <p>Preamble</p>

                  <Accordion defaultActiveKey="0">
                    {secondAccordionItems.map((item, index) => (
                      <Accordion.Item eventKey={index.toString()} key={index}>
                        <Accordion.Header>{item.title}</Accordion.Header>
                        <Accordion.Body><p>{item.content}</p></Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <Contact_details_card />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Terms_and_condition;
